// extracted by mini-css-extract-plugin
export default {"h3":"H3title_h3__zSLGt","white":"H3title_white__+O+Lw"};